import React, { useState } from "react";
//import Papa from "papaparse";
import { getPokerServiceLocationBase } from '../api/data';

// Allowed extensions for input file
const allowedExtensions = ["csv"];

export const FileUploadSingle = ({processCallback, uploadMessage}) => {
	
	// This state will store the parsed data
	//const [data, setData] = useState([]);
	
	// It state will contain the error when
	// correct file extension is not used
	//const [error, setError] = useState("");
	
	// It will store the file uploaded by the user
	const [file, setFile] = useState<string>("");

	// This function will be called when
	// the file input changes
	const handleFileChange = (e) => {
		//setError("");
		
		// Check if user has entered the file
		if (e.target.files.length) {
			const inputFile = e.target.files[0];
			
			// Check the file extensions, if it not
			// included in the allowed extensions
			// we show the error
			const fileExtension = inputFile?.type.split("/")[1];
			if (!allowedExtensions.includes(fileExtension)) {
				//setError("Please input a csv file");
				return;
			}

			// If input type is correct set the state
			setFile(inputFile);
		}
	};

	/*const handleParse = () => {
		
		// If user clicks the parse button without
		// a file we show a error
		if (!file) return setError("Enter a valid file");

		// Initialize a reader which allows user
		// to read any file or blob.
		const reader = new FileReader();
		
		// Event listener on reader when the file
		// loads, we parse it and set the data.
		reader.onload = async ({ target }) => {
			alert('file: ' + target.result);
			const csv = Papa.parse(target.result, { header: true });
			const parsedData = csv?.data;
			alert('parsedData: ' + parsedData);
			const columns = Object.keys(parsedData[0]);
			setData(columns);
		};
		reader.readAsText(file);
	};*/

	const handleProcess = () => {
		//alert('Processing...');
		// If user clicks the parse button without
		// a file we show a error
		if (file === '') {
			alert('Error: Please select a file.');
			return;
			//return setError("Enter a valid file");
		}

		// Initialize a reader which allows user
		// to read any file or blob.
		const reader = new FileReader();
		
		// Event listener on reader when the file
		// loads, we parse it and set the data.
		reader.onload = async ({ target }) => {
			//alert('file: ' + target.result);
			if (target === null) {
				alert('file is null');
			} else {
				submitFileData(target.result);
			}
		};
		const fileBlob = new Blob([file], { type: 'text/plain' });
		reader.readAsText(fileBlob);
	};

	const submitFileData = (fileData) => {

		//alert('Submitting...\n' + fileData);
		const postRequestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: fileData
		};
		//event.preventDefault();

		alert(uploadMessage);
		fetch(getPokerServiceLocationBase() + '/ledger/', postRequestOptions)
			.then(function(response) {
				return response.text();
			}).then(function(data) {
				alert(data); // this will be a string
				processCallback();
			});
	};

	return (
		<div style={{textAlign: 'left'}}>
			<label htmlFor="csvInput" style={{ fontFamily: "Arial, sans-serif", fontSize: "14px" }}>
				Choose a CSV File:
			</label>
			<br />
			<input
				onChange={handleFileChange}
				id="csvInput"
				name="file"
				type="File"
			/>
			<div>
				<button disabled={file === ''} onClick={handleProcess}>Process</button>
				<br />
				{/*<button onClick={handleParse}>Parse</button>&nbsp;(Ignore this)
				<br />*/}
			</div>
			{/*<div style={{ marginTop: "3rem" }}>
				{error ? error : data.map((col,
				idx) => <div key={idx}>{col}</div>)}
			</div>*/}
		</div>
	);
};

//export default FileUploadSingle;
